import { render } from "./cloudflare_pdf.vue?vue&type=template&id=7b3f9f70&scoped=true"
import script from "./cloudflare_pdf.vue?vue&type=script&lang=js"
export * from "./cloudflare_pdf.vue?vue&type=script&lang=js"

import "./cloudflare_pdf.vue?vue&type=style&index=0&id=7b3f9f70&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3f9f70"]])

export default __exports__